import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isNative, storage } from '../utils/platform';

// Routes accessibles en native sans redirection auto :
//  - /m/welcome       → landing onboarding (Session 7 A1.10)
//  - /m/*             → routes mobile principales (home, avis, insights, profil)
//  - /login           → connexion
//  - /register        → inscription
//  - /forgot-password → demande reset password
//  - /reset-password  → reset depuis lien email
const NATIVE_ALLOWED_ROUTES = [
  '/m/',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
];

export default function NativeRouteGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [bootstrapped, setBootstrapped] = useState(!isNative());

  useEffect(() => {
    if (!isNative()) {
      setBootstrapped(true);
      return;
    }

    let cancelled = false;

    (async () => {
      const token = await storage.get('token');
      if (cancelled) return;

      const onAllowedRoute = NATIVE_ALLOWED_ROUTES.some(route =>
        location.pathname.startsWith(route)
      );

      if (token) {
        // Déjà connecté : si on est sur une route hors /m/*, retour app mobile.
        if (!location.pathname.startsWith('/m/')) {
          console.log('[NativeRouteGuard] Token + route web → /m/home');
          navigate('/m/home', { replace: true });
        }
      } else if (!onAllowedRoute) {
        // Non connecté : autoriser /m/welcome + flux auth, sinon redirect landing.
        console.log('[NativeRouteGuard] No token → /m/welcome');
        navigate('/m/welcome', { replace: true });
      }

      setBootstrapped(true);
    })();

    return () => { cancelled = true; };
  }, [location.pathname, navigate]);

  // En native, ne pas afficher le contenu tant que la redirection n'est pas tranchée
  // (sinon flash de la landing pendant 50ms avant redirect /m/home si token présent).
  if (!bootstrapped && isNative()) {
    return (
      <div style={{
        minHeight: '100dvh',
        background: '#EDEAE3',
      }} />
    );
  }

  return children;
}
